import memoizeOne from 'memoize-one';
import { connect } from 'react-redux';
import { AnyAction } from 'redux';
import { VirtualBrand } from '~/Api/Analytics/Autocomplete/VirtualBrand';
import { ThunkDispatch } from '~/Store';
import Autocomplete, { Option } from '~/UI/Autocomplete/Autocomplete';

import { loadBrands } from './actions';
import { selectBrands, State as BrandsState } from './reducer';

interface State {
	medicinalBrandsAnalyticsBrandAutocomplete: BrandsState;
}

interface OwnProps {
	value?: string | string;
	selectedIds?: string[] | string;
	onChange?: (value: string) => void;
}

const mapOptions = memoizeOne((brands: VirtualBrand[]): Option[] => {
	return brands.map((brand) => ({ id: brand.name, title: brand.name }));
});

const filterOptions = memoizeOne((options: Option[], query: string): Option[] => {
	const lowerCasedQuery = query.toLowerCase();
	const filteredOptions = options.filter((option) => option.title.toLowerCase().includes(lowerCasedQuery));
	filteredOptions.sort((a, b) => a.title.localeCompare(b.title));
	return filteredOptions;
});

const mapSelectedOptions = memoizeOne((selectedNames: string[]): Option[] => {
	return selectedNames.map((name) => ({ id: name, title: name }));
});

function mapStateToProps(
	{ medicinalBrandsAnalyticsBrandAutocomplete }: State,
	{ value, selectedIds }: OwnProps
): {
	options: Option[];
	selectedOptions: Option[];
} {
	const brands = selectBrands(medicinalBrandsAnalyticsBrandAutocomplete, value || '')?.items || [];
	const options = mapOptions(brands);

	const normlizaedSelectedIds = selectedIds || [];
	return {
		options: filterOptions(options, value || ''),
		selectedOptions: mapSelectedOptions(
			Array.isArray(normlizaedSelectedIds) ? normlizaedSelectedIds : [normlizaedSelectedIds]
		),
	};
}

function mapDispatchToProps(
	dispatch: ThunkDispatch<AnyAction>,
	{ onChange }: OwnProps
): {
	onChange(value: string): void;
} {
	return {
		onChange: (value: string) => {
			onChange?.(value);
			if (value !== '') {
				dispatch(loadBrands(value));
			}
		},
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(Autocomplete);
